import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Impressum from '../components/Impressum/Impressum';

const Services = () => {
    return (
        <>
            <Navbar />
            <Impressum />
            <Footer />
        </>
    );
};

export default Services;